export const registerToolbarHandlers = ref => {
  const fontSizeEl = ref.current.querySelector('.ck-font-size-dropdown');
  const fontFamilyEl = ref.current.querySelector('.ck-font-family-dropdown');

  const fontFamilyHandler = () => {
    const optionsEl = fontFamilyEl?.querySelector('.ck-dropdown__panel');
    optionsEl?.querySelectorAll('span.ck.ck-button__label').forEach(i => {
      if (i.innerText === 'Default') {
        i.innerText = 'Arial';
      }
    });
  };

  const fontSizeHandler = () => {
    const optionsEl = fontSizeEl?.querySelector('.ck-dropdown__panel');
    optionsEl?.querySelectorAll('span.ck.ck-button__label').forEach(i => {
      if (i.innerText === 'Default') {
        i.innerText = '11';
      }
    });
  };

  fontFamilyEl?.addEventListener('click', fontFamilyHandler);
  fontSizeEl?.addEventListener('click', fontSizeHandler);

  return () => {
    fontFamilyEl?.removeEventListener('click', fontFamilyHandler);
    fontSizeEl?.removeEventListener('click', fontSizeHandler);
  };
};
